import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LocizeBackend from 'i18next-locize-backend';
import moment from 'moment/min/moment-with-locales';
import Validators from 'redux-form-validators';
import 'moment/locale/es';
import { translationLanguageCodeOrFallback } from './helpers';
import { reconcileTranslationCache } from './version';
import { createLocalStorageBackendOptions } from './translationVersion';

const namespaces = [
  'common',
  'actions',
  'employee',
  'error',
  'file',
  'form',
  'flexflow',
  'history',
  'liquidationList',
  'modals',
  'nav',
  'overview',
  'payroll',
  'settings',
  'superAdmin',
  'toasts'
];

const formatInterpolation = (value, format) => {
  switch (format) {
    case 'uppercase':
      return value.toUpperCase();
    case 'lowercase':
      return value.toLowerCase();
    case 'capitalize':
      return `${value?.substr(0, 1)?.toUpperCase()}${value?.substr(1)}`;
    default:
      return value;
  }
};

const locizeBackendOptions = {
  reloadInterval: false,
  projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
  cdnType: 'standard',
  version: 'latest'
};
const localStorageBackendOptions = createLocalStorageBackendOptions();
const localStorageBackend = new LocalStorageBackend(null, localStorageBackendOptions);

export const momentIntl = moment;

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init(
    {
      react: {
        useSuspense: true
      },
      returnNull: false,
      defaultNS: 'common',
      saveMissing: false,
      lng: translationLanguageCodeOrFallback(navigator.language),
      ns: namespaces,
      debug: false,
      fallbackLng: 'es',
      interpolation: {
        escapeValue: false,
        format: (value, format) => formatInterpolation(value, format)
      },
      backend: {
        backends: [localStorageBackend, LocizeBackend],
        backendOptions: [localStorageBackendOptions, locizeBackendOptions]
      }
    },
    () => {
      momentIntl.locale(i18n.language);
      // todo add more and add translations
      Object.assign(Validators.messages, {
        notANumber: i18n.t('messages.invalid', { ns: ['form'] }),
        presence: i18n.t('messages.field is required', { ns: ['form'] }),
        email: i18n.t('messages.invalid', { ns: ['form'] }),
        dateRange: i18n.t('messages.dateRange', { ns: ['form'] }),
        greaterThan: i18n.t('messages.greaterThan', { ns: ['form'] }),
        greaterThanOrEqualTo: i18n.t('messages.greaterThanOrEqualTo', { ns: ['form'] }),
        lessThanOrEqualTo: i18n.t('messages.lessThanOrEqualTo', { ns: ['form'] }),
        tooLong: i18n.t('messages.tooLong', { ns: ['form'] })
      });

      reconcileTranslationCache(i18n, localStorageBackend).catch(() => {});
    }
  );

export default i18n;
